<template>
  <div class="app-centered-column__container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CenteredColumn'
}
</script>

<style scoped>
.app-centered-column__container {
  display: flex;
  flex-grow: 100;
  flex-direction: column;
  height: 100%;
  margin: 0 auto;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
}

@media screen and (min-width: 960px) {
  .app-centered-column__container {
    max-width: 60rem;
  }
}

@media screen and (max-width: 960px) {
  .app-centered-column__container {
    width: 100%;
  }
}
</style>
